import React from 'react'
import styles from './AmountComponent.module.css'
import classNames from 'classnames'

interface AmountComponentProps {
  amount: number
  currency: string
  coloured?: boolean
}

export const AmountComponent: React.FC<AmountComponentProps> = ({ amount, currency, coloured }) => {
  const int = Math.round(amount).toString()
  const formatted = int.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
  const formattedUnrounded = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " " + currency
  return <span title={formattedUnrounded} className={classNames({[styles.amount]: true, [styles.green]: coloured && amount > 0, [styles.red]: coloured && amount < 0})}>{formatted}&nbsp;{currency}</span>
};
